import log from 'loglevel';
import { v4 as uuidv4 } from 'uuid';
import { fromJS, Map } from 'immutable';
import socket from '../socket';
import { SESSION_NAME } from '../constants';
import { GenericRequestMessageType } from '../protocol/genericMessage';
import { buildRequest, parseResponse } from '../protocol/jovo';
import { gatherDeviceInfo } from '../utils/clientInfo';
import * as PMD from '../pending-messages-director';
// import { getLocalSession, storeParamsTo } from '../store/reducers/helper';

export class JovoSocketIoSocket {
    constructor(
        url,
        customData,
        path,
        protocol,
        protocolOptions,
        onSocketEvent,
        browserStorage,
        getBrowserLocationPathname,
        pendingMessagesRules,
        uniqueMessageTypes,
        onEmit,
        getLocale
    ) {
        this.url = url;
        this.customData = customData;
        this.path = path;
        this.protocol = protocol;
        this.protocolOptions = {
            autoConnect: true,
            reconnection: true,
            reconnectionAttempts: 3000,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 8000,
            ...protocolOptions,
        };
        this.onSocketEvent = onSocketEvent || {};
        this.socket = null;
        this.onEvents = [];
        this.marker = Math.random();
        this.browserStorage = browserStorage;
        this.getBrowserLocationPathname = getBrowserLocationPathname;
        this.getLocale = getLocale;
        // this.newSession = undefined;
        this.sessionId = undefined;
        this.pendingSessionMessages = PMD.newPendingMessagesDirector(
            pendingMessagesRules,
            uniqueMessageTypes
        );
        this.onEmit = onEmit || ((message, payload) => payload);
    }

    /*
    isFirstMessage() {
        const session = this.getStorageData(SESSION_NAME);
        const peerConversation = session
            && session.conversation
            && session.conversation.filter(({ sender }) => sender != 'client');

        return !peerConversation || peerConversation.length <= 0;
    }
    */

    isNewSession() {
        const session = this.browserStorage.get(SESSION_NAME);

        return !session || !session.session_id || session.session_id != this.sessionId;
    }

    getJovoRequestState() {
        return this.browserStorage.get('jovo_request_state');
    }

    setJovoRequestState(state) {
        this.browserStorage.set('jovo_request_state', state);
    }

    clearJovoRequestState() {
        this.browserStorage.set('jovo_request_state', {});
    }

    clearSessionState() {
        this.clearJovoRequestState();
        this.browserStorage.update(SESSION_NAME, { conversation: [] });
    }

    isInitialized() {
        return !!this.socket;
    }

    on(event, callback) {
        const handleBotUtteredEvent = (botData) => {
            log.debug('bot_uttered data', botData);

            /*
            botData && botData.output && botData.output.push({
                type: 'carousel',
                panels: [{
                    title: 'Titel 1 foo bar baz foo bar baz foo bar baz foo bar',
                    subtitle: 'Dies ist ein Subtitle, foo bar baz foo bar baz\n\nfoo _bar baz foo_ bar __baz foo bar__ baz aaa aaa bbb bbb ccc ccc ddd ddd eee eee [this is a link](https://google.de)\n\n'
                        + '- foo\n- bar\n- baz\n\nfoo bar baz\n\n1. dings\n2. bums',
                    //title: 'foo',
                    //subtitle: 'foobar',
                    // imageUrl: 'https://www.startus.cc/sites/default/files/styles/company_profile_gallery_image/public/company-profile-gallery/sipgate4.png',
                    // imageUrl: 'https://static.sipgate.com/botify/images/red-500.png',
                    imageUrl: 'https://static.sipgate.com/botify/images/tariff-test_phase-info-01-02-01.png',
                    action: {
                        url: 'https://sipgate.de'
                    },
                    buttons: [{
                        text: 'Text 1',
                        payload: 'just a text reply'
                    }, {
                        text: 'Intent 1',
                        variant: 'default',
                        payload: { intent: 'some-intent' }
                    }, {
                        text: 'Url 1',
                        variant: 'loud',
                        payload: { url: 'quickreply2-url' }
                    }, {
                        text: 'Internal Link 1 foo bar baz foo bar baz foo bar baz foo bar baz',
                        variant: 'quiet',
                        payload: { internalUrlName: 'usersOverview' }
                    }]
                }, {
                    title: 'Titel 2',
                    subtitle: 'Subtitel 2, mit ein bisschen __Text__, so dass man mal sehen kann wie der Text so im Carousel-Panel fliesst und ob das okay aussieht.\n\nAnsonsten la le lu, nur der Mann im Mond schaut zu.',
                    // imageUrl: 'https://static.sipgate.com/botify/images/blue-500.png',
                    imageUrl: 'https://static.sipgate.com/botify/images/tariff-test_phase-info-01-03-01.png',
                    action: {
                        url: 'https://sipgate.de'
                    },
                    buttons: [{
                        text: 'Text 2',
                        payload: 'just a text reply'
                    }, {
                        text: 'Intent 2',
                        payload: { intent: 'some-intent' }
                    }, {
                        text: 'Url 2',
                        payload: { url: 'quickreply2-url' }
                    }, {
                        text: 'Internal Link 2',
                        payload: { internalUrlName: 'settingsProducts' }
                    }]
                }, {
                    title: 'Titel 3',
                    subtitle: 'Subtitel 3',
                    // imageUrl: 'https://static.sipgate.com/botify/images/green-500.png',
                    // imageUrl: 'https://static.sipgate.com/botify/images/tariff-test_phase-info-01-04-01.png',
                    imageUrl: 'https://www.svgrepo.com/show/429529/notes-currency-3.svg',
                    action: {
                        url: 'https://sipgate.de'
                    },
                    buttons: [{
                        text: 'Text 3',
                        payload: 'just a text reply'
                    }, {
                        text: 'Intent 3',
                        payload: { intent: 'some-intent' }
                    }, {
                        text: 'Url 3',
                        payload: { url: 'quickreply2-url' }
                    }, {
                        text: 'Internal Link 3',
                        payload: { internalUrlName: 'settingsPortedNumbers' }
                    }]
                }, {
                    title: 'Titel 4',
                    subtitle: 'Subtitel 4, diesmal mal ein Panel ohne Image.',
                    // imageUrl: 'https://static.sipgate.com/botify/images/green-500.png',
                    //imageUrl: 'https://static.sipgate.com/botify/images/tariff-test_phase-info-01-04-01.png',
                    action: {
                        url: 'https://sipgate.de'
                    },
                    buttons: [{
                        text: 'Text 3',
                        payload: 'just a text reply'
                    }, {
                        text: 'Intent 3',
                        payload: { intent: 'some-intent' }
                    }, {
                        text: 'Url 3',
                        payload: { url: 'quickreply2-url' }
                    }, {
                        text: 'Internal Link 3',
                        payload: { internalUrlName: 'settingsPortedNumbers' }
                    }]
                }]
            });
            */
            /*
            botData && botData.output && botData.output.push({
                type: 'quickReply',
                message: 'Ein paar Buttons',
                turnID: 'llm-answer',
                buttons: [{
                    text: 'External Link',
                    payload: { url: 'https://sipgate.de' }
                }, {
                    text: 'AppWeb usersOverview',
                    variant: 'default',
                    payload: { internalUrlName: 'usersOverview' }
                }, {
                    text: 'AppWeb settingsProducts',
                    variant: 'loud',
                    payload: { internalUrlName: 'settingsProducts' }
                }, {
                    text: 'AppWeb settingsPortedNumbers',
                    variant: 'quiet',
                    payload: { internalUrlName: 'settingsPortedNumbers' }
                }, {
                    text: 'AppWeb contactList',
                    payload: { internalUrlName: 'contactList' }
                }, {
                    text: 'AppWeb itemizedBill',
                    payload: { internalUrlName: 'itemizedBill' }
                }, {
                    text: 'AppWeb settingsPhoneNumbers',
                    payload: { internalUrlName: 'settingsPhoneNumbers' }
                }, {
                    text: 'AppWeb settingsBookNumbers',
                    payload: { internalUrlName: 'settingsBookNumbers' }
                }, {
                    text: 'AppWeb settingsMobileNumberImport',
                    payload: { internalUrlName: 'settingsMobileNumberImport' }
                }, {
                    text: 'AppWeb settingsInvoices',
                    payload: { internalUrlName: 'settingsInvoices' }
                }, {
                    text: 'AppWeb settingsLocation',
                    payload: { internalUrlName: 'settingsLocation' }
                }, {
                    text: 'AppWeb settingsAccount',
                    payload: { internalUrlName: 'settingsAccount' }
                }, {
                    text: 'AppWeb settingsAccountConfigure',
                    payload: { internalUrlName: 'settingsAccountConfigure' }
                }, {
                    text: 'AppWeb settingsAccountCredit',
                    payload: { internalUrlName: 'settingsAccountCredit' }
                }, {
                    text: 'AppWeb settingsAccountCreditAuto',
                    payload: { internalUrlName: 'settingsAccountCreditAuto' }
                }, {
                    text: 'AppWeb settingsUserSetupMisc',
                    payload: { internalUrlName: 'settingsUserSetupMisc' }
                }, {
                    text: 'AppWeb devicePool',
                    payload: { internalUrlName: 'devicePool' }
                }, {
                    text: 'AppWeb devicePoolBookContingent with some super long text added to the title',
                    payload: { internalUrlName: 'devicePoolBookContingent' }
                }, {
                    text: 'AppWeb verifyAccount',
                    payload: { internalUrlName: 'verifyAccount' }
                }, {
                    text: 'AppWeb routing',
                    payload: { internalUrlName: 'routing' }
                }, {
                    text: 'AppWeb cancelAccount',
                    payload: { internalUrlName: 'cancelAccount' }
                }, {
                    text: 'AppWeb eventList',
                    payload: { internalUrlName: 'eventList' }
                }, {
                    text: 'AppWeb groupsOverview',
                    payload: { internalUrlName: 'groupsOverview' }
                }, {
                    text: 'AppWeb notifications',
                    payload: { internalUrlName: 'notifications' }
                }, {
                    text: 'Text',
                    payload: 'just a text reply'
                }, {
                    text: 'QuickReply',
                    payload: { intent: 'some-intent' }
                }]
            });
            */
            /*
            // buttons without text:
            botData && botData.output && botData.output.push({
                type: 'quickReply',
                buttons: [{
                    text: 'External Link',
                    payload: { url: 'https://sipgate.de' }
                }, {
                    text: 'Text',
                    payload: 'just a text reply'
                }, {
                    text: 'QuickReply',
                    payload: { intent: 'some-intent' }
                }]
            });
            */
            /*
            botData && botData.output && botData.output.push({
                type: 'text',
                turnID: 'llm-answer',
                message: '# Headline\n\nSupertext und ein [Link](https://sipgate.de) dazu.\n\nAbsatz 1 weorih 24h *qwrfnoqi* 40h4 oiqhw f092h **41in2o** rj102h4\n\n- aaa\n- bbb\n- ccc\n\n1. aaa1\n2. bbb2\n3. ccc3\n\nwoier q3209q inf 3q4h1j 0i23ho'
            });
            */
            /*
            botData && botData.output && botData.output.push({
                type: 'image',
                title: 'Tolles Image',
                url: 'https://www.startus.cc/sites/default/files/styles/company_profile_gallery_image/public/company-profile-gallery/sipgate4.png'
            });
            */
            /*
            botData && botData.output && botData.output.push({
                type: 'video',
                title: 'Tolles Video',
                url: 'https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4'
            });
            */

            const genericMessage = parseResponse(botData);

            genericMessage.state && this.setJovoRequestState(genericMessage.state);

            genericMessage.output && genericMessage.output.map(callback);
        };

        const handleSessionConfirmEvent = (...args) => {
            callback(...args);
        };

        const eventFallbackHandler = (...args) => {
            callback(...args);
        };

        const handlerMap = {
            session_confirm: handleSessionConfirmEvent,
            bot_uttered: handleBotUtteredEvent,
        };

        if (!this.socket) {
            this.onEvents.push({ event, callback });
        } else {
            this.socket.on(event, (...args) => {
                log.debug('received event', event, args);

                const handler = handlerMap[event] || eventFallbackHandler;

                handler && handler(...args);
            });
        }
    }

    emit(message, data, isSessionOptional, customerId, userId) {
        const buildPayload = (type, session_id, body) => {
            const applicationInfo = {
                location: this.getBrowserLocationPathname && this.getBrowserLocationPathname(),
            };

            const request = buildRequest({
                type,
                body,
                locale: this.getLocale ? this.getLocale() : 'de',
                device: gatherDeviceInfo(),
                application: applicationInfo,
                state: this.getJovoRequestState(),
            });

            const emitMessage = fromJS({
                session_id,
                payload: request,
            });

            return emitMessage
                .mergeDeep(fromJS({ payload: { context: { session: { id: session_id } } } }))
                .updateIn(['payload', 'context', 'user', 'id'], (id) =>
                    customerId ? customerId : id
                ) // for backwards compatibility
                .updateIn(['payload', 'context', 'user', 'customerId'], (id) =>
                    customerId ? customerId : id
                )
                .updateIn(['payload', 'context', 'user', 'userId'], (id) => (userId ? userId : id))
                .toJS();
        };

        const payloadHandlers = Map({
            user_uttered: () =>
                buildPayload(
                    typeof data.message === 'string'
                        ? GenericRequestMessageType.TEXT
                        : GenericRequestMessageType.INTENT,
                    this.sessionId,
                    data.message
                ),
            application_event: () =>
                buildPayload(
                    GenericRequestMessageType.APPLICATION_EVENT,
                    this.sessionId,
                    data.event
                ),
            launch_intent: () => buildPayload(GenericRequestMessageType.LAUNCH, this.sessionId, {}),
            deeplink: () =>
                buildPayload(GenericRequestMessageType.DEEPLINK, this.sessionId, data.deeplink),
        });

        if (this.socket && this.socket.connected && (this.sessionId || isSessionOptional)) {
            const payload = this.onEmit(message, payloadHandlers.get(message, () => data)());

            log.debug('emit message', message, payload, data);

            this.socket.emit(message, payload);
        } else {
            log.debug('queueing message until socket connection & session exist', message, data);

            PMD.push(this.pendingSessionMessages, { type: message, data, customerId, userId });
        }
    }

    emitWithCustomerInfo(message, data, customerId, userId) {
        return this.emit(message, data, undefined, customerId, userId);
    }

    emitWithoutSession(message, data) {
        return this.emit(message, data, true);
    }

    emitOnlyOnNewSession(message, data, customerId, userId) {
        if (!this.socket || !this.socket.connected || !this.sessionId) {
            log.debug(
                'explicitly queueing message until socket connection & session exist',
                message,
                data,
                customerId,
                userId
            );

            PMD.push(this.pendingSessionMessages, { type: message, data, customerId, userId });
        } else {
            log.debug(
                'discarding message, as session already exists',
                message,
                data,
                customerId,
                userId
            );
        }
    }

    emitPendingSessionMessages() {
        const messages = PMD.popAll(this.pendingSessionMessages) || [];

        // NOTE: we usually only want to send these pending messages once per session, not
        //   once per socket connection (as widget might lose connection arbitrarily). so,
        //   we'll only emit pending messages if we've received a fresh sessionId:
        if (this.isNewSession()) {
            log.debug('new session => send pending messages', messages.length);

            messages.map(({ type, data, customerId, userId }) => {
                try {
                    this.emit(type, data, undefined, customerId, userId);
                } catch (e) {
                    log.warn(
                        'error while trying to send pending message',
                        type,
                        data,
                        customerId,
                        userId,
                        e
                    );
                }
            });
        } else {
            log.debug("discarding pending messages, as we don't have a new session");
        }
    }

    off(event) {
        this.socket && this.socket.off(event);

        this.onEvents = this.onEvents.filter((handler) => handler && handler.event != event);
    }

    close() {
        if (this.socket) {
            this.socket.close();
        }
    }

    isConnected() {
        if (this.socket) {
            return this.socket.connected;
        }
    }

    createSocket() {
        this.socket = socket(
            this.url,
            this.customData,
            this.path,
            this.protocol,
            this.protocolOptions
        );

        // We set a function on session_confirm here so as to avoid any race condition
        // this will be called first and will set those parameters for everyone to use.
        this.socket.on('session_confirm', (sessionObject) => {
            log.debug('session_confirm jovo-socketio', sessionObject);
            this.sessionConfirmed = true;
            this.sessionId =
                sessionObject && sessionObject.session_id
                    ? sessionObject.session_id
                    : sessionObject;

            if (this.isNewSession()) {
                log.debug('sessionId has changed => new session => clear session state');
                this.clearSessionState();
            }

            this.emitPendingSessionMessages();
        });
        this.socket.on('disconnect', (reason) => {
            if (reason === 'io server disconnect') {
                // as socket.io does not try to reconnect on this reason
                setTimeout(() => this.socket.connect(), 1000);
            }
        });
        this.onEvents.forEach((event) => {
            this.socket.on(event.event, event.callback);
        });

        this.onEvents = [];
        Object.keys(this.onSocketEvent).forEach((event) => {
            this.socket.on(event, this.onSocketEvent[event]);
        });
    }
}
